module.exports = __webpack_public_path__ + "static/media/Macizo Intro.5db2920a.mp4";